import { render, staticRenderFns } from "./LogFollow.vue?vue&type=template&id=79c37801&"
import script from "./LogFollow.vue?vue&type=script&lang=js&"
export * from "./LogFollow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports